import { render, staticRenderFns } from "./RtGtmImpressionSentinel.vue?vue&type=template&id=10650503&scoped=true"
import script from "./RtGtmImpressionSentinel.vue?vue&type=script&setup=true&lang=ts"
export * from "./RtGtmImpressionSentinel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RtGtmImpressionSentinel.vue?vue&type=style&index=0&id=10650503&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10650503",
  null
  
)

export default component.exports